export default __webpack_public_path__ + "static/media/MNP.4375fdcc.svg";